export class LinkMemberRequest {
    body: Body = new Body();
}

export class Body {
    ProcessName: string = "DC Community Portal SR Process Wrapper WF";
    DCMethod: string = "SAVEASDRAFT";
    DCLanguage: string = "ENU";
    DCLoginName: string = "PRAKASHPOOJARY";
    DCIncomingHierarchy: DCIncomingHierarchy = new DCIncomingHierarchy();
}

export class DCIncomingHierarchy {
    MessageId: string = "123456";
    IntObjectName: string = "DC Community Portal SR Upsert IO";
    MessageType: string = "Integration Object";
    IntObjectFormat: string = "Siebel Hierarchical";
    ["ListOfDC Community Portal SR Upsert IO"]: ListOfDCCommunityPortalSRUpsertIO =
        new ListOfDCCommunityPortalSRUpsertIO();
}

export class ListOfDCCommunityPortalSRUpsertIO {
    ["DC Community Portal SR"]: DCCommunityPortalSR = new DCCommunityPortalSR();
}

export class DCCommunityPortalSR {
    "SR Number": string = "";
    "CSN": string = "";
    "SR Type": string = "";
    "Sub Type": string = "";
    "DC Payment Method": string = "Online";
    "DC Channel": string = "Online";
    "DC Link CSN": string = "";
    "DC Link UserID": string = "";
    "DC Link Mem Answer1": string = "";
    "DC Link Mem Answer2": string = "";
    "DC Link Mem Answer3": string = "";
    'DC Holder Mobile': string = "";
}
